import React, { useReducer } from "react";

let reducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            return { ...state, isAuthenticated: true, accessToken: action.payload };
        case "REFRESH":
            return { ...state, isAuthenticated: true, accessToken: action.payload };
        case "LOGOUT":
            return { ...state, isAuthenticated: false, accessToken: action.payload, isManager: false, profile: null, cashPickupLocations: [] };
        case "IS_MANAGER":
            return { ...state, isManager: true };
        case "ADD_PROFILE":
            return { ...state, profile: action.payload };
        case "ADD_CASH_PICKUP_LOCATIONS":
            return { ...state, cashPickupLocations: action.payload };
        case "ADD_COUNTRIES":
            return { ...state, countries: action.payload };
        default:
            return state;
    }
};

const initialState = { isAuthenticated: false, accessToken: '', isManager: false, profile: null, cashPickupLocations: [], countries: [] }

const AuthContext = React.createContext(initialState);

function AuthProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <AuthContext.Provider value={{ state, dispatch }}>
            {props.children}
        </AuthContext.Provider>
    );
}

export { AuthContext, AuthProvider };